import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin } from 'lucide-react'

const navLinks = [
  { to: '/servizi',      label: 'Servizi' },
  { to: '/eventi',       label: 'Eventi' },
  { to: '/contatti',     label: 'Contatti' },
  { to: '/safeguarding', label: 'Safeguarding' },
  { to: '/donazioni', label: 'Donazioni' },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer style={{ backgroundColor: '#603300', borderTop: '1px solid #B45309' }}>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">

          {/* Colonna 1 — Brand */}
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 group" // Usa gap-1 o gap-2 per tenerli vicini
            >
              <img
                src="/images/logo1.png"
                alt="Logo 1"
                className="h-10 w-auto object-contain transition-opacity duration-200 group-hover:opacity-80"
              />
              <img
                src="/images/logo2.png"
                alt="Logo 2"
                className="h-10 w-auto object-contain transition-opacity duration-200 group-hover:opacity-80"
              />
            </Link>
            <p className="text-sm font-sans leading-relaxed mt-4 max-w-xs text-white/80">
              Associazione Sportiva Dilettantistica e di Promozione Sociale.<br />
              Organizzazione di eventi scacchistici agonistici e promozionali.
            </p>
            <div className="mt-6 w-12 h-px bg-white/40" />
          </div>

          {/* Colonna 2 — Link */}
          <div>
            <h4 className="font-serif text-base mb-5 tracking-wide text-white">
              Navigazione
            </h4>
            <ul className="space-y-2">
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-white/75 hover:text-white transition-colors duration-200 font-sans"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonna 3 — Contatti */}
          <div>
            <h4 className="font-serif text-base mb-5 tracking-wide text-white">
              Contatti
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-white mt-0.5 shrink-0" />
                <div className="text-sm font-sans leading-relaxed text-white/75">
                  <a href="tel:+393473154178" className="hover:text-white transition-colors block">
                    +39 347 315 4178
                  </a>
                  <a href="tel:+393299092748" className="hover:text-white transition-colors block">
                    +39 329 909 2748
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="text-white mt-0.5 shrink-0" />
                <div className="text-sm font-sans leading-relaxed text-white/75">
                  <a href="https://mail.google.com/mail/?view=cm&to=info@agonfievele.org" target="_blank" rel="noopener noreferrer" className="hover:text-white/70 transition-colors block">
                    info@agonfievele.org
                  </a>
                  <a href="https://mail.google.com/mail/?view=cm&to=arroccorocchetti@gmail.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/70 transition-colors block">
                    arroccorocchetti@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-white mt-0.5 shrink-0" />
                <p className="text-sm font-sans leading-relaxed text-white/75">
                  Strada Palazzone 1<br />
                  05022 Amelia (TR)
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-sans tracking-wide text-white/60">
            © {year} ASD – APS A Gonfie Vele. Tutti i diritti riservati.
          </p>
          <a
            href="https://gregoriocaruso.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-sans tracking-wide text-white hover:text-white/70 transition-colors duration-200"
          >
            Sviluppo Sito Web
          </a>
        </div>
      </div>
    </footer>
  )
}